module.exports = __webpack_public_path__ + "static/media/PP6-Tablet.a968d8fa.png";


//////////////////
// WEBPACK FOOTER
// ./src/Assets/Paper6/PP6-Tablet.png
// module id = 296
// module chunks = 0